define(function (require, exports) {
    'use strict';
    // @ngInject
    exports.metToggle = function () {

        /**
         * @param {ng.IQService} $q
         * @param {ng.IHttpService} $http
         */
        // @ngInject
        this.$get = function ($http, $q, lpCoreUtils, metroContext) {
            var config = {
                toggleEndpoint: lpCoreUtils.resolvePortalPlaceholders('$(servicesPath)/services/rest/toggle/all'),
                sweepsEndpoint: lpCoreUtils.resolvePortalPlaceholders('$(servicesPath)/services/rest/sweeps/toggle/poc'),
            };

            function API() {
                var ToggleModel = function () {
                    this.sweeps = '';
                };
                ToggleModel.prototype.getToggle = function () {
                    var self = this;
                    var deferred = $q.defer();

                    self.loading = true;

                        $http.get(config.toggleEndpoint,{data: {}}).success(function (data) {
                            self.errorCode = null;

                            deferred.resolve(data);
                        }).error(function (data) {
                            self.errorCode = data.errors[0].code || 500;
                            deferred.reject(data);
                        }).finally(function () {
                            self.loading = false;
                        });

                    return deferred.promise;
                }
                ToggleModel.prototype.getSweeps = function () {
                    var self = this;
                    var deferred = $q.defer();

                    self.loading = true;

                        $http.get(config.sweepsEndpoint,{data: {}}).success(function (data) {
                            self.errorCode = null;

                            deferred.resolve(data);
                        }).error(function (data) {
                            self.errorCode = data.errors[0].code || 500;
                            deferred.reject(data);
                        }).finally(function () {
                            self.loading = false;
                        });

                    return deferred.promise;
                }
                return new ToggleModel();
            }

            return {
                setConfig: function (options) {
                    config = lpCoreUtils(options).chain()
                        .mapValues(lpCoreUtils.resolvePortalPlaceholders)
                        .defaults(config)
                        .value();
                    return this;
                },

                getConfig: function (prop) {
                    if (prop && lpCoreUtils.isString(prop)) {
                        return config[prop];
                    }

                    return config;
                },

                api: API
            };
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/services/metToggleProvider.js